import React, { FC } from 'react';
import { Control, Controller, FieldErrors, UseFormRegister, UseFormSetValue, useWatch } from 'react-hook-form';

import { LinkButton } from '@eika/button';
import { CurrencyInput } from '@eika/currency-input';
import { IconTypes } from '@eika/icon';
import { Input } from '@eika/input';

import { useTranslation } from '../../translations';
import Arbeidssituasjon from './arbeidssituasjon';
import { InntektFormData } from './inntekt';

interface Props {
    index: number;
    register: UseFormRegister<InntektFormData>;
    control: Control<InntektFormData>;
    setValue: UseFormSetValue<InntektFormData>;
    errors: FieldErrors<InntektFormData>;
    onClickSlett: (index: number) => void;
}

const InntektKunde: FC<Props> = ({ index, register, control, setValue, errors, onClickSlett }) => {
    const { inntekt, validationMessage, button } = useTranslation();
    const value = useWatch({ name: 'inntekt', control });

    return (
        <>
            <Input
                label={inntekt.labelArbeidsgiver}
                type="text"
                error={errors.inntekt?.[index]?.arbeidsgiver?.message}
                {...register(`inntekt.${index}.arbeidsgiver` as const, {
                    required: `${validationMessage.requiredValue}`,
                })}
            />
            <Arbeidssituasjon index={index} register={register} control={control} setValue={setValue} errors={errors} />
            <Controller
                control={control}
                name={`inntekt.${index}.aarsinntektKunde` as const}
                rules={{
                    required: `${validationMessage.requiredValue}`,
                }}
                render={({ field: { onChange } }) => (
                    <CurrencyInput
                        className="max-width-200"
                        label={inntekt.labelInntekt}
                        placeholder=""
                        type="tel"
                        value={value?.[index]?.aarsinntektKunde || 0}
                        error={errors.inntekt?.[index]?.aarsinntektKunde?.message}
                        name={`inntekt.${index}.aarsinntekt` as const}
                        onValueChange={(v) => {
                            const newValue = v.value.startsWith('0') ? v.value.slice(1) : v.value;
                            onChange(newValue);
                        }}
                    />
                )}
            />
            <div className="column">
                <LinkButton
                    icon={IconTypes.SLETT_24}
                    data-track-id="kreditt-boliglaan-inntekt-slett-ikon"
                    data-track-linkname="fjern"
                    onClick={() => onClickSlett(index)}
                >
                    {button.fjern}
                </LinkButton>
            </div>
        </>
    );
};

export default InntektKunde;
